const apiUrl = 'https://restapi.tchrnote.com';
const cloudUrl = 'https://restapi.tchrnote.com/api/parent';

const environment = {
    notifications: `${apiUrl}/cx/qpass/notifications`,
    circulars: `${apiUrl}/cx/qpass/circulars`,
    studentDiary: `${apiUrl}/cx/qpass/studentdiary`,
    liveClasses: `${cloudUrl}?serviceName=todayLiveClasses`,
    assessments: `${cloudUrl}?serviceName=assessments`,
    assignments: `${apiUrl}/cx/qpass/assignments`,
    oqExamsResults: `${apiUrl}/cx/qpass/oq-exams-results`,
    ptm: `${apiUrl}/cx/qpass/ptm`,
    servicerequest: `${apiUrl}/cx/qpass/servicerequest`,
    exams: `${apiUrl}/cx/qpass/exams`,
    examschedule: `${apiUrl}/cx/qpass/examschedule`,
    examresult: `${apiUrl}/cx/qpass/examresult`,
    finance: `${apiUrl}/cx/qpass/finance`,
    events: `${apiUrl}/cx/qpass/events`,
    remarks: `${apiUrl}/cx/qpass/remarks`,
    feedback: `${apiUrl}/cx/qpass/feedback`,
    attendanceSummary: `${apiUrl}/cx/qpass/attendance-summary`,
    timetable: `${apiUrl}/cx/qpass/timetable`,
    dashboard: `${apiUrl}/cx/qpass/dashboard`,
    transport: `${apiUrl}/cx/qpass/transport`,
    gallery: `${apiUrl}/cx/qpass/gallery`,
    classroom: `${apiUrl}/cx/qpass/classroom`,
    calendar: `${apiUrl}/cx/qpass/calendar`,
    familydetails: `${apiUrl}/cx/qpass/family-details`,
    enclosers: `${apiUrl}/cx/qpass/enclosers`,
    invoices: `${apiUrl}/cx/qpass/invoices`,
    schoolCircle: `${apiUrl}/cx/qpass/circleposts`,
    onlinePayementRequest: `${cloudUrl}?serviceName=onlinePayementRequest`,
    addSibling: `${cloudUrl}?serviceName=addSibling`,
    otherAssessments: `${apiUrl}/cx/qpass/othrAssessments`,
};

export default environment;